module.exports = __webpack_public_path__ + "static/media/truck_9t.e7db2567.svg";